import type { ReactNode } from 'react'
import { Box, Container, Stack, Typography } from '@mui/material'

const BRAND = '#2563eb'
const BRAND_ACCENT = '#0ea5e9'

const orbitaMark = (
  <svg width="30" height="30" viewBox="0 0 24 24" fill="none">
    <ellipse cx="12" cy="12" rx="9" ry="3.6" transform="rotate(-25 12 12)" stroke="currentColor" strokeWidth="1.6" />
    <circle cx="12" cy="12" r="3" fill="currentColor" />
  </svg>
)

// Cabeçalho das telas públicas do app (login, recuperação de senha, troca de senha) --
// mesma marca Órbita da tela de contratação, pra manter o topo consistente. O crédito da
// softhouse (SMS Murilo) fica no AppFooter, embaixo.
export function PublicHeader({ action }: { action?: ReactNode }) {
  return (
    <Box
      component="header"
      sx={{
        borderBottom: '1px solid', borderColor: 'divider',
        bgcolor: 'background.paper', backdropFilter: 'blur(14px) saturate(150%)',
        position: 'sticky', top: 0, zIndex: 10,
      }}
    >
      <Container maxWidth="md" sx={{ py: 1.5, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
        <Stack
          component="a"
          href="https://orbita.smsmurilo.com.br/"
          direction="row"
          alignItems="center"
          gap={1.5}
          sx={{ textDecoration: 'none', color: 'text.primary' }}
        >
          <Box sx={{ width: 44, height: 44, borderRadius: 2.5, display: 'grid', placeItems: 'center', color: 'white', background: `linear-gradient(135deg,${BRAND},${BRAND_ACCENT})`, boxShadow: '0 10px 26px -10px rgba(37,99,235,.5)' }}>
            {orbitaMark}
          </Box>
          <Typography fontWeight={800} fontSize="1.3rem">Órbita</Typography>
        </Stack>
        {action}
      </Container>
    </Box>
  )
}
